import React, { useState } from 'react'
import { Link, usePage } from '@inertiajs/react'

import { Typography } from '@material-tailwind/react'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa6'
import { MdOutlineFileDownload } from 'react-icons/md'
import { addDays } from 'date-fns'

import Layout from '@/Shared/Layout'
import BreadCrumbs from '@/Shared/BreadCrumbs'
import DatePicker from '@/Shared/DatePicker'

import { getLabel } from '@/utils'

const now = new Date(Date.now())

const Index = () => {
    const { hospitals, item } = usePage().props

    const [data, setData] = useState(hospitals)
    const [sortColumn, setSortColumn] = useState({
        id: 0,
        name: 0,
        consumable: 0,
        consumed: 0
    })
    const [range, setRange] = useState({
        from: now,
        to: addDays(now, 20)
    })

    function sortByColumn(column) {
        if (sortColumn[column] === 0) {
            setSortColumn({
                ...sortColumn,
                [column]: 1
            })
        } else if (sortColumn[column] === 1) {
            setSortColumn({
                ...sortColumn,
                [column]: -1
            })
        } else {
            setSortColumn({
                ...sortColumn,
                [column]: 0
            })
        }

        let sortedData = hospitals

        if (column === 'id') {
            if (sortColumn[column] === 1) {
                sortedData = hospitals.sort((a, b) => a.id - b.id)
            }

            if (sortColumn[column] === -1) {
                sortedData = hospitals.sort((a, b) => b.id - b.id)
            }
        }

        if (column === 'name') {
            if (sortColumn[column] === 1) {
                sortedData = hospitals.sort((a, b) => {
                    const nameA = a.name.toUpperCase()
                    const nameB = b.name.toUpperCase()

                    if (nameA < nameB) {
                        return -1
                    }

                    if (nameA > nameB) {
                        return 1
                    }

                    return 0
                })
            }

            if (sortColumn[column] === -1) {
                sortedData = hospitals.sort((a, b) => {
                    const nameA = a.name.toUpperCase()
                    const nameB = b.name.toUpperCase()

                    if (nameA > nameB) {
                        return -1
                    }

                    if (nameA < nameB) {
                        return 1
                    }

                    return 0
                })
            }
        }

        if (column === 'consumable') {
            if (sortColumn[column] === 1) {
                sortedData = hospitals.sort((a, b) => parseInt(a.consumable_quantity) - parseInt(b.consumable_quantity))
            }

            if (sortColumn[column] === -1) {
                sortedData = hospitals.sort((a, b) => parseInt(b.consumable_quantity) - parseInt(a.consumable_quantity))
            }
        }

        if (column === 'consumed') {
            if (sortColumn[column] === 1) {
                sortedData = hospitals.sort((a, b) => parseInt(a.consumed_quantity) - parseInt(b.consumed_quantity))
            }

            if (sortColumn[column] === -1) {
                sortedData = hospitals.sort((a, b) => parseInt(b.consumed_quantity) - parseInt(a.consumed_quantity))
            }
        }

        setData(sortedData)
    }

    return (
        <div>
            <BreadCrumbs link="consumable.janitorial" title={`${getLabel(item)} Description`} subTitle="List" />

            <div className="mb-4 flex items-center justify-between">
                <h1 className="text-3xl font-bold">
                    <span className="text-indigo-400">{getLabel(item)}</span> Description
                </h1>

                <div className="hidden md:flex gap-x-2 items-center">
                    <DatePicker
                        mode="range"
                        date={range}
                        setDate={setRange}
                    />

                    <a
                        href={route('consumable.detail.export', {
                            item,
                            _query: range
                        })}
                        type="button"
                        color="blue-gray"
                        className="mb-1 flex items-center gap-2 rounded-lg p-2 text-sm font-semibold hover:bg-blue-gray-500/10 active:bg-blue-gray-500/30"
                    >
                        <MdOutlineFileDownload size={25} /> Export
                    </a>
                </div>
            </div>

            <div className="overflow-x-auto rounded bg-white shadow">
                <table className="w-full whitespace-nowrap">
                    <thead>
                    <tr className="text-left font-bold">
                        <th
                            className="cursor-pointer bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            onClick={() => sortByColumn('id')}
                        >
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="flex items-center justify-between gap-2 font-normal leading-none opacity-70"
                            >
                                Sr No.{' '}
                                {sortColumn['id'] === 1 ? (
                                    <FaChevronUp strokeWidth={2} className="h-4 w-4" />
                                ) : (
                                    <FaChevronDown strokeWidth={2} className="h-4 w-4" />
                                )}
                            </Typography>
                        </th>

                        <th
                            className="cursor-pointer bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            onClick={() => sortByColumn('name')}
                        >
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="flex items-center justify-between gap-2 font-normal leading-none opacity-70"
                            >
                                Name{' '}
                                {sortColumn['name'] === 1 ? (
                                    <FaChevronUp strokeWidth={2} className="h-4 w-4" />
                                ) : (
                                    <FaChevronDown strokeWidth={2} className="h-4 w-4" />
                                )}
                            </Typography>
                        </th>

                        <th
                            className="cursor-pointer bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            onClick={() => sortByColumn('consumable')}
                        >
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="flex items-center justify-between gap-2 font-normal leading-none opacity-70"
                            >
                                Total Sent Quantity{' '}
                                {sortColumn['consumable'] === 1 ? (
                                    <FaChevronUp strokeWidth={2} className="h-4 w-4" />
                                ) : (
                                    <FaChevronDown strokeWidth={2} className="h-4 w-4" />
                                )}
                            </Typography>
                        </th>

                        <th
                            className="cursor-pointer bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            onClick={() => sortByColumn('consumed')}
                        >
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="flex items-center justify-between gap-2 font-normal leading-none opacity-70"
                            >
                                Consumed Quantity{' '}
                                {sortColumn['consumed'] === 1 ? (
                                    <FaChevronUp strokeWidth={2} className="h-4 w-4" />
                                ) : (
                                    <FaChevronDown strokeWidth={2} className="h-4 w-4" />
                                )}
                            </Typography>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.map(
                        (
                            { id, name, consumable_quantity, consumed_quantity },
                            index
                        ) => {
                            return (
                                <tr
                                    key={id}
                                    className="focus-within:bg-gray-100 hover:bg-gray-100"
                                >

                                    <td className="border-t focus:text-indigo px-6 py-4 focus:outline-none">
                                        <Link
                                            tabIndex="-1"
                                            href={route('consumed.hospital.create', {
                                                item,
                                                hospital: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {index + 1}
                                        </Link>
                                    </td>


                                    <td className="border-t focus:text-indigo px-6 py-4 focus:outline-none">
                                        <Link
                                            tabIndex="-1"
                                            href={route('consumed.hospital.create', {
                                                item,
                                                hospital: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {name}
                                        </Link>
                                    </td>


                                    <td className="border-t focus:text-indigo px-6 py-4 focus:outline-none">
                                        <Link
                                            tabIndex="-1"
                                            href={route('consumed.hospital.create', {
                                                item,
                                                hospital: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {consumable_quantity}
                                        </Link>
                                    </td>


                                    <td className="border-t focus:text-indigo px-6 py-4 focus:outline-none">
                                        <Link
                                            tabIndex="-1"
                                            href={route('consumed.hospital.create', {
                                                item,
                                                hospital: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {consumed_quantity}
                                        </Link>
                                    </td>
                                </tr>
                            )
                        }
                    )}
                    {hospitals.length === 0 && (
                        <tr>
                            <td className="border-t px-6 py-4" colSpan="4">
                                No users found.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

Index.layout = page =>
    <Layout title="Consumable Item Description" children={page} />

export default Index
